import { Component, inject } from '@angular/core';
import { KeycloakUserService } from './services/keycloak-user.service';
import { environment } from 'src/environments/environment.production';
import { RouterBreadcrumbService } from './errors/router-breadcrumb';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  title = 'dashboard-frontend';
  userIsAllowed : boolean = false;

  constructor(private keycloakUserService : KeycloakUserService){
    inject(RouterBreadcrumbService);
    this.userIsAllowed = this.keycloakUserService.userHasRole(environment.production? 'prod':'dev','gateway');
  }

}
